import React, { Fragment, useContext, useEffect, useState } from "react";
import { AppContext, paymentCfg } from "../../../../components/AppProvider";
import { PostApi1604, PostApi1607, SetPGTrsn } from "../../../../modules/network/padoPost";
import { _O } from "../../../../modules/utils";
import { postApiToJson } from "../../../../modules/network/Network";
import { NativeAction } from "../../../../modules/utils/HandleWs";

export default (props) => {
  // const sub = SUBS[3];
  const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);
  const [payList, setPayList] = useState();
  const [prodNm, setProdNm] = useState("");

  const [totalPrice, setTotalPrice] = useState();

  // props.match.params
  const request1604 = (seqNo, prodType) => {
    PostApi1604(userinfo.userToken, cfg, phonecfg, seqNo, prodType)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          // _O.Open("/proof/payment");
          setPayList(res.result);
          circulatePrice(res.result, setTotalPrice);

          if (res.result.length - 1 > 1) {
            setProdNm(res.result[0].docTypeNm + " 외 " + (res.result.length - 1) + "건");
          } else {
            setProdNm(res.result[0].docTypeNm);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const request1607 = (seqNo, payMth, payAmount, trnsnType, trnsnId, trnsnRslt) => {
    PostApi1607(userinfo, cfg, phonecfg, seqNo, payMth, payAmount, trnsnType, trnsnId, trnsnRslt)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          _O.Open("/proof/storage/3/1/1");
        } else {
          console.log(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const pay = () => {
    // _O.Open("/proof/download");
    // _O.Open("/proof/storage");

    request1607(payList[0].seqNo, "01", totalPrice, "02", "9999", "E000");
  };

  const requestSetPGTrsn = (
    aplnSeqNo,
    payMth,
    payAmount,
    prodNm,
    rsltCd,
    rsltMsg,
    authPageUrl,
    bizType
  ) => {
    let authorizationId = authPageUrl.substring(authPageUrl.indexOf("=") + 1, authPageUrl.length);

    SetPGTrsn(
      userinfo,
      cfg,
      aplnSeqNo,
      payMth,
      payAmount,
      prodNm,
      rsltCd,
      rsltMsg,
      authPageUrl,
      authorizationId,
      bizType
    ).then((res) => {
      if (res.resultMsg === "SUCCESS") {
        _O.Open(
          "/cmmn/iframeBody/" +
            encodeURIComponent(authPageUrl) +
            "/" +
            encodeURIComponent("/pmr/proofList/3/1/1")
        );
        // if(phonecfg.phoneOS === 'ANDROID') {
        //     // window.open(authPageUrl);
        //     console.log(authPageUrl);
        //     _O.Open("/cmmn/iframeBody/" + encodeURIComponent(authPageUrl));
        // } else {
        //     window.location.href = authPageUrl;
        // }
      } else {
        alert("결제연동 실패");
      }
    });
  };

  useEffect(() => {
    request1604(props.match.params.seqNo, "C");
  }, []);

  const payment = (payMthCd, amount, goodsName) => {
    // const url = "https://pgapi.easypay.co.kr/api/trades/webpay";
    const url = paymentCfg.url;
    // const url = 'https://testpgapi.easypay.co.kr/api/trades/webpay';
    const rtnUrl = cfg.webUrl + "payment/?userToken=";
    const rtnUIUrl = "pmr/proof/result/";

    const payData = {
      // 운영
      mallId: paymentCfg.mallId,
      // 테스트
      // "mallId" : 'T0010932'
      payMethodTypeCode: payMthCd,
      currency: "00",
      amount: amount,
      clientTypeCode: "00",
      returnUrl:
        rtnUrl +
        userinfo.userToken +
        "&rtnUIUrl=" +
        rtnUIUrl +
        "&phoneOS=" +
        phonecfg.phoneOS +
        "&bizType=" +
        "PR",
      shopOrderNo: props.match.params.seqNo, // aplnSeqNo
      deviceTypeCode: "mobile",
      orderInfo: {
        goodsName: goodsName,
      },
    };

    postApiToJson(url, payData).then((res) => {
      if (res.resCd === "0000") {
        // aplnSeqNo, payMth, payAmount, prodNm, rsltMsg, authPageUrl
        requestSetPGTrsn(
          props.match.params.seqNo,
          payMthCd,
          amount,
          goodsName,
          res.resCd,
          res.resMsg,
          res.authPageUrl,
          "PF"
        );
      } else {
        alert("에러:::" + res.resMsg);
      }
    });
  };

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <ScrollToTop />
      {/* <Container Title="결제" proof="PAYMENT" onClick={()=>pay()}> */}
      <Container Title="결제">
        <div className="contents sub grad">
          {/* <SubMenu code={sub.code} sub={SUBS} /> */}

          <div className="sub-contents">
            <div className="steps-bar-area">
              <ul>
                <li style={{ width: "50%" }}>
                  <a
                    style={{
                      height: "55px",
                      lineHeight: "55px",
                      fontSize: "15px",
                      fontWeight: "bold",
                      border: "0px",
                    }}
                    onClick={() => _O.OpenMenu("/pmr/proofRecipt")}
                  >
                    제증명 신청
                  </a>
                </li>
                <li className="on" style={{ width: "50%" }}>
                  <a
                    style={{
                      height: "55px",
                      lineHeight: "55px",
                      fontSize: "15px",
                      fontWeight: "bold",
                      border: "0px",
                    }}
                    onClick={() => _O.OpenMenu("/pmr/proofList/3/1/1")}
                  >
                    제증명 보관함
                  </a>
                </li>
                {/* <li><a>STEP 4</a></li> */}
              </ul>
            </div>
            <div className="sub-title">결제를 진행해 주세요.</div>
            <div className="device-state-info res">
              병원마다 결제금액이 상이할 수 있음을 알려드립니다.
            </div>

            {payList && <PayInfo payList={payList} totalPrice={totalPrice} />}

            <div className="sub-title">결제수단</div>
            <div className="pay-sel-boxes">
              <ul>
                <li>
                  <label>
                    <input type="radio" name="radio1" />
                    <div onClick={() => payment("11", totalPrice, prodNm)}>
                      <i className="c1"></i>
                      <span>신용카드</span>
                    </div>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </Fragment>
  );
};

export const PayInfo = (props) => {
    const {payList, totalPrice} = props;
    
    return (
        <div className="pay-state-info">
            <ul>
                {payList.map((m,i) => (
                    m.docTypeCd != '999'
                        &&  m.sortNo === "1"
                            ?   m.cnclLineYn === "N"
                                ?   <li key={i}><span>{m.docTypeNm}</span> <p>{priceToString(m.prodPrice)}원</p></li>
                                :   <li key={i}><span>{m.docTypeNm}</span> <p><text style={{textDecoration:"line-through"}}>{priceToString(m.orgProdPrice)}원</text> {priceToString(m.prodPrice)}원</p></li>
                            :   <li key={i}>
                                    <span>{m.docTypeNm}</span> 
                                    <p>
                                        {priceToString(m.prodPrice)}원
                                    </p>
                                </li>
                ))}
            </ul>
            <div>
                <span>결제금액</span>
                <em> {priceToString(totalPrice)}원</em>
            </div>
        </div>
    );
}

export function circulatePrice(payList, setTotalPrice) {
    let price = 0;
    
    for (let i = 0; i < payList.length; i++) {
        if(payList[i].docTypeNm != "환불금액") {
            if(payList[i].orgProdPrice != '') {
                price = price + parseInt(payList[i].orgProdPrice);
            } else {
                price = price + parseInt(payList[i].prodPrice);
            }
            
        } 
        else {
            price = price - payList[i].prodPrice;
        }
    }

    setTotalPrice(price);
}

function priceToString(price) {
    let returnVal;

    if(price) {
        returnVal = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
        returnVal = '0';
    }
    return returnVal;
}